import React from 'react';
import './notFound.css';
import { Button } from "@mui/material";
import Cookies from "js-cookie";
import swal from "sweetalert";
import { useNavigate } from "react-router-dom";

const NotFoundPage = () => {

  const navigate = useNavigate();

  const removeUser = async () => {
    try {
        Cookies.remove("fullName");
        Cookies.remove("userRole");
        Cookies.remove("accessToken");
        Cookies.remove("refreshToken");
        navigate("/");
      } 
     catch (error) {
      console.error("Error updating status: ", error);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-r from-blue-950 via-blue-900 to-blue-500 font-inter">
      <div className="text-center">
        <p className='font-black text-6xl' style={{ color: '#00F0FF', position: 'absolute', top: '20%', left: '50%', transform: 'translate(-50%, -50%)' }}>404</p>
        <p className='font-bold  text-3xl' style={{ color: '#00F0FF', position: 'absolute', top: '35%', left: '50%', transform: 'translate(-50%, -50%)' }}>Page Not Found.</p>
        <p className='font-bold text-3xl' style={{ color: '#00F0FF', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>Sorry, we can’t find the page you’re looking for.</p>
        <Button
          variant="contained"
          color="primary"
          onClick={removeUser}
          style={{ backgroundColor: "#3C7B97", boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.2)", position: 'absolute', top: '60%', left: '50%', transform: 'translate(-50%, -50%)' }}
        >
          Back to Home
        </Button>
      </div>
    </div>
  );
};
 
export default NotFoundPage;